<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view>
      <o-nav-bar
        title="Q8 Fuel on the Go"
        :has-back-button="true"
        :is-overlay="true"
      />
      <o-map />
      <o-section-header title="Tankstations" />
      <o-section>
        <p>
          We hebben meerdere tankstations gevonden in jouw buurt waarbij je met
          KBC Mobile kunt betalen. Kies het station dat voor jou van toepassing
          is.
        </p>
        <o-list-item
          icon="brands-q8"
          icon-style="logo"
          label-right="300m"
          :no-padding="true"
          @click.native="$router.push('/sales/fuel/q8/stations/welcome')"
        >
          <template #label>
            Q8 Brusselsesteenweg<br />
            <span class="u-small u-muted">Brusselsesteenweg 100</span><br />
            <span class="u-small u-muted">3000 Leuven</span>
          </template>
        </o-list-item>
      </o-section>
      <o-section>
        <o-list-item
          icon="brands-q8"
          icon-style="logo"
          label-right="300m"
          :no-padding="true"
        >
          <template #label>
            Q8 Ridderstraat<br />
            <span class="u-small u-muted">Ridderstraat 25</span><br />
            <span class="u-small u-muted">3000 Leuven</span>
          </template>
        </o-list-item>
      </o-section>
    </o-view>
  </o-view>
</template>

<script>
import OEmptyState from '@/components/OEmptyState.vue'
import OMap from '@/components/OMap.vue'
import OPayButton from '@/components/OPayButton.vue'
export default {
  name: 'CambioOnboardingConfirmation',
  components: {
    OEmptyState,
    OMap,
    OPayButton
  }
}
</script>

<style lang="scss"></style>
